import moment from 'moment';
import masker from 'vanilla-masker';

export class MascaraUtil {
  static cpf = (valor: string): string =>
    valor
      ?.replace(/\D/g, '')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1');

  static cnpj = (valor: string): string =>
    valor
      ?.replace(/\D+/g, '')
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .replace(/(-\d{2})\d+?$/, '$1');

  static cpfCnpj = (valor: string): string => {
    const resultado = this.removerMascara(valor);
    if (resultado.length <= 11) {
      return resultado
        ?.replace(/\D/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
    } else {
      return resultado
        ?.replace(/\D+/g, '')
        .replace(/(\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
    }
  };

  static removerMascara = (valor: string): string => valor.replace(/\D/g, '');

  static telefone = (valor: string): string => {
    const numeros = valor?.replace(/\D/g, '').slice(0, 11);

    if (numeros?.length == 11) {
      return numeros?.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    } else {
      return numeros?.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }
  };

  static dinheiro = (valor: number, exibirUnidade = true) =>
    masker.toMoney(valor.toFixed(2), {
      precision: 2,
      separator: ',',
      unit: exibirUnidade ? 'R$' : '',
    });

  static data = (valor: string, formato?: string) => {
    if (formato) return moment(valor, formato).format('DD/MM/YYYY');

    return moment(valor).format('DD/MM/YYYY');
  };

  static dataEHora = (valor: string, formato?: string) => {
    if (formato)
      return `${moment(valor, formato).format('DD/MM/YYYY')} às ${moment(valor, formato).format(
        'HH:mm',
      )}`;

    return `${moment(valor).format('DD/MM/YYYY')} às ${moment(valor).format('HH:mm')}`;
  };

  static dataEHoraPadrao = (valor: string, horas?: boolean, valorHoras?: string) => {
    const data = moment(valor);

    if (horas) {
      if (valorHoras) {
        const [h, m] = valorHoras.split(':');
        data.set({ hour: Number(h), minute: Number(m), second: 0 });
      }
      return data.format('YYYY-MM-DDTHH:mm');
    }
    return data.format('YYYY-MM-DD');
  };

  static numero = (valor: string): string => valor.replace(/[^0-9]/gi, '');
}
